module.exports = __webpack_public_path__ + "img/profile-01.a4834deb.jpg";